// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","logo":"Header_logo__UsziS","options":"Header_options__6wuv2","active":"Header_active__rHuVo"};